module.exports = __webpack_public_path__ + "static/media/ourProducts.9431849e.svg";